module.exports = __webpack_public_path__ + "static/media/bran.cf4cc263.jpg";